/** Parse calendar dates as local civil dates; never derive a date from a UTC timestamp. */
export function parseDateValue(value: string): Date | undefined {
  const match = /^(\d{4})-(\d{2})-(\d{2})(?:T.*)?$/.exec(value);

  if (!match) {
    return;
  }

  const [, year, month, day] = match.map(Number),
    date = new Date(0);

  date.setFullYear(year, month - 1, day);
  date.setHours(12, 0, 0, 0);

  return date.getFullYear() === year && date.getMonth() === month - 1 && date.getDate() === day
    ? date
    : undefined;
}

export function dateValue(date: Date) {
  return `${String(date.getFullYear()).padStart(4, '0')}-${String(date.getMonth() + 1).padStart(2, '0')}-${String(date.getDate()).padStart(2, '0')}`;
}

export function dateFieldError(
  value: string,
  timed: boolean,
  min?: string | number,
  max?: string | number,
) {
  if (!value) {
    return '';
  }

  if (
    !parseDateValue(value) ||
    !(timed ? /^\d{4}-\d{2}-\d{2}T(?:[01]\d|2[0-3]):[0-5]\d$/ : /^\d{4}-\d{2}-\d{2}$/).test(value)
  ) {
    return timed
      ? 'Choose a valid date and time (YYYY-MM-DDTHH:mm).'
      : 'Choose a valid date (YYYY-MM-DD).';
  }

  if (min && value < String(min)) {
    return `Choose ${min} or later.`;
  }

  if (max && value > String(max)) {
    return `Choose ${max} or earlier.`;
  }

  return '';
}
